import { Link } from 'react-router-dom';
import './ContentPage.css';

const Privacy = () => (
  <main className="content-page">
    <div className="content-page__container">
      <nav className="content-crumbs" aria-label="Хлебные крошки">
        <Link to="/">Главная</Link>
        <span aria-hidden="true">/</span>
        <span>Политика конфиденциальности</span>
      </nav>

      <header className="content-page__header">
        <h1 className="content-page__title">Политика конфиденциальности</h1>
        <p className="content-page__lead">
          Порядок обработки и защиты персональных данных пользователей сайта ЕнотМани.
        </p>
      </header>

      <article className="content-panel legal-text">
        <h2>1. Общие положения</h2>
        <p>
          1.1. Настоящая Политика конфиденциальности разработана в соответствии с Федеральным законом № 152-ФЗ
          «О персональных данных» и определяет порядок обработки и защиты персональных данных пользователей сайта.
        </p>
        <p>
          1.2. Оператором персональных данных является владелец сервиса ЕнотМани. По вопросам обработки данных
          пишите в Telegram @enot_mani.
        </p>

        <h2>2. Какие данные собираются</h2>
        <p>2.1. При использовании сайта могут обрабатываться следующие данные:</p>
        <ul>
          <li>фамилия, имя, отчество;</li>
          <li>контактный телефон;</li>
          <li>адрес электронной почты;</li>
          <li>иные данные, которые пользователь предоставляет добровольно;</li>
          <li>технические данные об использовании сайта в обезличенном виде.</li>
        </ul>

        <h2>3. Цели обработки данных</h2>
        <p>3.1. Персональные данные используются для:</p>
        <ul>
          <li>предоставления информации о финансовых продуктах;</li>
          <li>обработки обращений пользователей;</li>
          <li>обратной связи;</li>
          <li>аналитики и улучшения работы сайта;</li>
          <li>направления информационных сообщений при наличии согласия.</li>
        </ul>

        <h2>4. Передача данных</h2>
        <p>
          4.1. При переходе к оформлению продукта на сайте банка или компании пользователь взаимодействует уже с
          этим сервисом. Обработка данных на стороне третьих лиц регулируется их собственными документами.
        </p>

        <h2>5. Защита данных</h2>
        <p>
          5.1. Мы применяем организационные и технические меры, направленные на защиту данных от неправомерного
          доступа, изменения, раскрытия или уничтожения.
        </p>

        <h2>6. Права пользователя</h2>
        <p>
          6.1. Пользователь может запросить уточнение, обновление или удаление своих персональных данных, направив
          обращение в Telegram @enot_mani.
        </p>

        <h2>7. Изменения политики</h2>
        <p>
          7.1. Мы можем обновлять эту Политику. Актуальная версия всегда доступна на данной странице.
        </p>
      </article>

        <section className="content-banner">
          <div>
            <h2>Остались вопросы по данным?</h2>
            <p>Напишите нам в Telegram — ответим по обработке персональных данных.</p>
          </div>
          <a
            href="https://t.me/enot_mani"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--primary"
          >
            Написать в Telegram
          </a>
        </section>
    </div>
  </main>
);

export default Privacy;
